var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "select-card" },
    [
      _c("div", { staticClass: "select-card-header" }, [
        _c("div", { staticClass: "sch-left" }, [
          _c("h2", [_vm._v("Select an App to connect")]),
          _c("p", [
            _vm._v(
              "\n        Choose the App under your merchant account to link to this " +
                _vm._s(_vm.platformLabel) +
                " store.\n        The App ID and Secret Key will be automatically passed to " +
                _vm._s(_vm.platformLabel) +
                " after you confirm.\n      "
            ),
          ]),
        ]),
        _c("div", { staticClass: "sch-right" }, [
          _c("div", { staticClass: "mid-label" }, [_vm._v("Merchant ID")]),
          _c("div", { staticClass: "mid-val" }, [
            _vm._v(_vm._s(_vm.merchantId || "—")),
          ]),
        ]),
      ]),
      _c("app-table", {
        attrs: {
          apps: _vm.apps,
          "selected-app-id": _vm.selectedAppId,
          loading: _vm.loading,
          regions: _vm.regions,
        },
        on: {
          select: function ($event) {
            return _vm.$emit("select", $event)
          },
        },
      }),
      _c("div", { staticClass: "select-card-footer" }, [
        _c("div", { staticClass: "footer-hint" }, [
          _vm.selectedApp
            ? _c("span", { staticClass: "footer-selected" }, [
                _vm._v("\n        Selected: "),
                _c("strong", [_vm._v(_vm._s(_vm.selectedApp.app_name))]),
                _c("span", { staticClass: "app-id-hint" }, [
                  _vm._v(_vm._s(_vm.selectedApp.app_id)),
                ]),
              ])
            : _c("span", { staticClass: "footer-empty" }, [
                _vm._v(
                  "\n        No app selected — click a row above to select\n      "
                ),
              ]),
        ]),
        _c(
          "button",
          {
            staticClass: "btn-green",
            attrs: { disabled: !_vm.canConfirm || _vm.confirming },
            on: {
              click: function ($event) {
                return _vm.$emit("confirm")
              },
            },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.confirming ? "Confirming..." : "Confirm Selection") +
                "\n      "
            ),
            !_vm.confirming
              ? _c(
                  "svg",
                  {
                    attrs: {
                      width: "14",
                      height: "14",
                      viewBox: "0 0 16 16",
                      fill: "currentColor",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z",
                      },
                    }),
                  ]
                )
              : _vm._e(),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }